
export type DeleteCard200 = {
  deletedBillingKey?: string;
  message?: string;
  success: boolean;
};
